import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { SortableElement } from "react-sortable-hoc";

// Locals
import CouDragHandle from "./CouDragHandle";
import CouImageThumbnail from "./CouImageThumbnail";

// Styled
const CouImageThumbnailHOCStyled = styled.div`
  position: relative;
  padding-left: ${props => (props.multiple ? "2.5rem" : 0)};
`;

// Const
const CouImageThumbnailHOC = props => (
  <CouImageThumbnailHOCStyled multiple={props.multiple}>
    {props.multiple && <CouDragHandle />}
    <CouImageThumbnail {...props} />
  </CouImageThumbnailHOCStyled>
);
const SortableCouImageThumbnail = SortableElement(CouImageThumbnailHOC);

// ------------------------------
// CouImageThumbnails
// ------------------------------
class CouImageThumbnails extends Component {
  render() {
    const { files, ...rest } = this.props;

    return (
      <div className="CouImageThumbnails">
        {files.map((file, index) => (
          <SortableCouImageThumbnail
            key={file.id}
            index={index}
            inputIndex={index}
            file={file}
            {...rest}
          />
        ))}
      </div>
    );
  }
}

CouImageThumbnails.propTypes = {
  files: PropTypes.array.isRequired
};

export default CouImageThumbnails;
